import {z} from 'zod'

export const TeamGroup = z.enum(['referring_doctor', 'therapist', 'almoner', 'psychologist', 'doctor', 'other'])
export type TeamGroup = z.infer<typeof TeamGroup>

export const TeamSpecializationGroup = z.enum([
    'referring_doctor',
    'therapist',
    'psychosocial_staff',
    'psychologist',
    'doctor',
    'other'
])
export type TeamSpecializationGroup = z.infer<typeof TeamSpecializationGroup>

export const TeamMember = z.object({
    id: z.string().min(1),
    group: TeamGroup,
    treatmentRequestId: z.string().min(1),
    projectId: z.string().min(1).nullable(),
    user: z.object({
        id: z.string().min(1),
        fullName: z.string().min(1),
        specializationName: z.string().min(1),
        specializationId: z.string().min(1)
    })
})
export type TeamMember = z.infer<typeof TeamMember>
